var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDropdownLivestream = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "active-dropdown",
    d: "M17.4613 35.4098C17.9737 35.4098 18.4093 35.213 18.9218 34.9302L33.8605 26.642C34.9239 26.0394 35.2954 25.6459 35.2954 24.9942C35.2954 24.3424 34.9239 23.9489 33.8605 23.3586L18.9218 15.0581C18.4093 14.7753 17.9737 14.5908 17.4613 14.5908C16.5132 14.5908 15.9238 15.2795 15.9238 16.3493V33.639C15.9238 34.7089 16.5132 35.4098 17.4613 35.4098Z",
    fill: "url(#paint0_linear_18939_74205)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "active-dropdown",
    d: "M17.4613 35.4098C17.9737 35.4098 18.4093 35.213 18.9218 34.9302L33.8605 26.642C34.9239 26.0394 35.2954 25.6459 35.2954 24.9942C35.2954 24.3424 34.9239 23.9489 33.8605 23.3586L18.9218 15.0581C18.4093 14.7753 17.9737 14.5908 17.4613 14.5908C16.5132 14.5908 15.9238 15.2795 15.9238 16.3493V33.639C15.9238 34.7089 16.5132 35.4098 17.4613 35.4098Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "active-dropdown",
    d: "M18.0436 40.6122L18.0466 40.6105L38.8967 28.6672L38.8967 28.6673L38.9086 28.6603C39.6712 28.2142 40.3593 27.7512 40.848 27.1812C41.4067 26.5293 41.6539 25.8022 41.6539 24.9911C41.6539 24.1808 41.4071 23.4517 40.845 22.7999C40.3534 22.2298 39.6621 21.7714 38.8975 21.3333C38.8975 21.3332 38.8974 21.3332 38.8973 21.3331C38.8972 21.3331 38.8971 21.333 38.897 21.3329L18.0474 9.37225L18.0474 9.37225L18.0436 9.37008C17.2723 8.93055 16.3815 8.5 15.2625 8.5C14.1962 8.5 13.2254 8.91556 12.5458 9.72288C11.8904 10.5016 11.6167 11.5092 11.6167 12.534V37.4483C11.6167 38.4728 11.8901 39.4815 12.5411 40.2626C13.2167 41.0733 14.1873 41.5 15.2625 41.5C16.3978 41.5 17.3005 41.0356 18.0436 40.6122Z",
    stroke: "url(#paint1_linear_18939_74205)",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "active-dropdown",
    d: "M18.0436 40.6122L18.0466 40.6105L38.8967 28.6672L38.8967 28.6673L38.9086 28.6603C39.6712 28.2142 40.3593 27.7512 40.848 27.1812C41.4067 26.5293 41.6539 25.8022 41.6539 24.9911C41.6539 24.1808 41.4071 23.4517 40.845 22.7999C40.3534 22.2298 39.6621 21.7714 38.8975 21.3333C38.8975 21.3332 38.8974 21.3332 38.8973 21.3331C38.8972 21.3331 38.8971 21.333 38.897 21.3329L18.0474 9.37225L18.0474 9.37225L18.0436 9.37008C17.2723 8.93055 16.3815 8.5 15.2625 8.5C14.1962 8.5 13.2254 8.91556 12.5458 9.72288C11.8904 10.5016 11.6167 11.5092 11.6167 12.534V37.4483C11.6167 38.4728 11.8901 39.4815 12.5411 40.2626C13.2167 41.0733 14.1873 41.5 15.2625 41.5C16.3978 41.5 17.3005 41.0356 18.0436 40.6122Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "inactive-dropdown",
    d: "M17.4613 35.4098C17.9737 35.4098 18.4093 35.213 18.9218 34.9302L33.8605 26.642C34.9239 26.0394 35.2954 25.6459 35.2954 24.9942C35.2954 24.3424 34.9239 23.9489 33.8605 23.3586L18.9218 15.0581C18.4093 14.7753 17.9737 14.5908 17.4613 14.5908C16.5132 14.5908 15.9238 15.2795 15.9238 16.3493V33.639C15.9238 34.7089 16.5132 35.4098 17.4613 35.4098Z",
    fill: "url(#paint0_linear_18872_18989)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "inactive-dropdown",
    d: "M17.4613 35.4098C17.9737 35.4098 18.4093 35.213 18.9218 34.9302L33.8605 26.642C34.9239 26.0394 35.2954 25.6459 35.2954 24.9942C35.2954 24.3424 34.9239 23.9489 33.8605 23.3586L18.9218 15.0581C18.4093 14.7753 17.9737 14.5908 17.4613 14.5908C16.5132 14.5908 15.9238 15.2795 15.9238 16.3493V33.639C15.9238 34.7089 16.5132 35.4098 17.4613 35.4098Z",
    fill: "#EFEBFF",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "inactive-dropdown",
    d: "M18.0436 40.6122L18.0466 40.6105L38.8967 28.6672L38.8967 28.6673L38.9086 28.6603C39.6712 28.2142 40.3593 27.7512 40.848 27.1812C41.4067 26.5293 41.6539 25.8022 41.6539 24.9911C41.6539 24.1808 41.4071 23.4517 40.845 22.7999C40.3534 22.2298 39.6621 21.7714 38.8975 21.3333C38.8975 21.3332 38.8974 21.3332 38.8973 21.3331C38.8972 21.3331 38.8971 21.333 38.897 21.3329L18.0474 9.37225L18.0474 9.37225L18.0436 9.37008C17.2723 8.93055 16.3815 8.5 15.2625 8.5C14.1962 8.5 13.2254 8.91556 12.5458 9.72288C11.8904 10.5016 11.6167 11.5092 11.6167 12.534V37.4483C11.6167 38.4728 11.8901 39.4815 12.5411 40.2626C13.2167 41.0733 14.1873 41.5 15.2625 41.5C16.3978 41.5 17.3005 41.0356 18.0436 40.6122Z",
    stroke: "url(#paint1_linear_18872_18989)",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "inactive-dropdown",
    d: "M18.0436 40.6122L18.0466 40.6105L38.8967 28.6672L38.8967 28.6673L38.9086 28.6603C39.6712 28.2142 40.3593 27.7512 40.848 27.1812C41.4067 26.5293 41.6539 25.8022 41.6539 24.9911C41.6539 24.1808 41.4071 23.4517 40.845 22.7999C40.3534 22.2298 39.6621 21.7714 38.8975 21.3333C38.8975 21.3332 38.8974 21.3332 38.8973 21.3331C38.8972 21.3331 38.8971 21.333 38.897 21.3329L18.0474 9.37225L18.0474 9.37225L18.0436 9.37008C17.2723 8.93055 16.3815 8.5 15.2625 8.5C14.1962 8.5 13.2254 8.91556 12.5458 9.72288C11.8904 10.5016 11.6167 11.5092 11.6167 12.534V37.4483C11.6167 38.4728 11.8901 39.4815 12.5411 40.2626C13.2167 41.0733 14.1873 41.5 15.2625 41.5C16.3978 41.5 17.3005 41.0356 18.0436 40.6122Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18939_74205",
    x1: 18.0614,
    y1: 17.6269,
    x2: 38.5762,
    y2: 19.4387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318247,
    stopColor: "#A6FF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FFF85C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18939_74205",
    x1: 16.1001,
    y1: 14.375,
    x2: 44.7467,
    y2: 16.8254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318247,
    stopColor: "#A6FF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FFF85C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18872_18989",
    x1: 18.0614,
    y1: 17.6269,
    x2: 38.5762,
    y2: 19.4387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A191F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18872_18989",
    x1: 16.1001,
    y1: 14.375,
    x2: 44.7467,
    y2: 16.8254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#1B1728"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDropdownLivestream);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dropdown-livestream.3c75d8b857fb7689c4bf1e5eb04cd49e.svg";